import { DealRoom } from 'models/DealRoom';

export type CommonTable = Pick<DealRoom, 'listing' | 'industry'> &
  Record<'state' | 'price' | 'ebitda', string>;

export const COMMON_TABLE_COLUMNS: Array<keyof CommonTable> = [
  'listing',
  'price',
  'ebitda',
  'state',
  'industry',
];

export const COMMON_HEADING_TRANSLATIONS = {
  listing: 'deal',
  price: 'price',
  state: 'location',
  industry: 'industry',
  ebitda: 'ebitda',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof COMMON_TABLE_COLUMNS[number], number>
> = {
  listing: 350,
  industry: 200,
};

export const DR_INVITATION_PAGE = 'drInvitationPage';
export const PRIVATE_INVITATION_PAGE = 'privateInvitationPage';

export const DR_INVITATION_LIMIT = 'dataRoomLimit';
export const PRIVATE_INVITATION_LIMIT = 'listingLimit';

export const REQUIRED_COLUMN = 'listing';
